import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Table, TableCell, TableContainer, TableHead, TableRow, TableBody } from "@mui/material";
import TablePagination from '@mui/material/TablePagination';
import TableFooter from '@mui/material/TableFooter';
import { useGetAllNotificationQuery } from "App/services/notificationServiceApi";
import NotificationFormDialog from "./components/NotificationFormDialog";
import { BASE_URL } from "baseConfig";
import parse from 'html-react-parser';
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/css/froala_style.min.css";

function Notification() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const { data: notifications, isLoading, isFetching } = useGetAllNotificationQuery({
    refetchOnFocus: false,
  });



  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const sortedNotifications = notifications?.slice().sort((a, b) => b.created_At - a.created_At) || [];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <MDTypography variant="h6" color="white">
                  Notification
                </MDTypography>
                <NotificationFormDialog />
              </MDBox>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Image</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Message</TableCell>
                      <TableCell>Details</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(rowsPerPage > 0
                      ? sortedNotifications.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      : sortedNotifications
                    ).map((notification) => (
                      <TableRow key={notification.id}>
                        {/* {console.log(notification)} */}
                        {notification.imagePath ? <TableCell sx={{ textAlign: 'left', cursor: 'pointer', '&:hover img': { transform: 'scale(1.05)', transition: 'transform 0.3s ease-in-out' } }}>
                          <img src={`${BASE_URL}${notification.imagePath}`} height={100} width={100} />
                        </TableCell> :
                          <TableCell sx={{ textAlign: 'left', cursor: 'pointer', '&:hover img': { transform: 'scale(1.05)', transition: 'transform 0.3s ease-in-out' } }}>
                         
                          </TableCell>}

                        <TableCell sx={{ textAlign: 'left' }}>
                          {notification.heading}
                        </TableCell>
                        <TableCell>{notification.message}</TableCell>
                        <TableCell>{parse(notification.notificationData)}</TableCell>

                      </TableRow>
                    ))}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                        colSpan={4}
                        count={sortedNotifications.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        SelectProps={{
                          inputProps: { 'aria-label': 'rows per page' },
                          native: true,
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Notification;
